import { LiveAnnouncer } from "@angular/cdk/a11y";
import { HttpClient } from "@angular/common/http"; // Added HttpClient
import { Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { provideNativeDateAdapter } from "@angular/material/core";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatSort, Sort } from "@angular/material/sort";
import { Subscription } from "rxjs";
import { DialogBoxComponent } from "../dialog-box/dialog-box.component";
import { EditDialogBoxComponent } from "../edit-dialog-box/edit-dialog-box.component";
import { ApiService } from "../services/api.service";
import { UserDataService } from "../services/user.service";
import { AppComponent } from "../app.component";
import { CookieService } from "ngx-cookie-service";

@Component({
  selector: "app-user",
  templateUrl: "./user.component.html",
  styleUrls: ["./user.component.css"],
  providers: [provideNativeDateAdapter()],
})
export class UserComponent implements OnInit, OnDestroy {
  private userDataSubscription: Subscription = new Subscription();
  showSpinner: boolean = true;
  public userData: any[] = [];
  pageEvent = { page: 0, pageSize: 1, totalPage: 0, totalRecords: 0 };
  displayedColumns: string[] = ["no", "eventId", "user", "activity", "event"];
  Search: string;
  Edit: string;
  value: string = "";
  search: string = "";
  page: number = 1;
  size: number = 10;
  sortField: string = "";
  sortType: string = "";
  refreshToken: string = "";
  noData: string;
  isError: boolean = false;
  
  clearInput() {
    this.value = "";
  }

  constructor(
    public dialog: MatDialog,
    private apiService: ApiService,
    private app: AppComponent,
    private http: HttpClient, // private apiService: ApiService
    private userDataService: UserDataService,
    private snackBar: MatSnackBar,
    private cookieService : CookieService,
  ) {
    this.Search = "/assets/icons/searchIcon.svg";
    this.Edit = "/assets/icons/editIcon.svg";
    this.noData = "/assets/icons/noData.jpg";
  }

  openDialog() {
    this.dialog.open(DialogBoxComponent);
  }

  openEditDialog(element: any) {
    const dialogRef = this.dialog.open(EditDialogBoxComponent, {
      width: "553px",
      data: element, // Pass the element data to the dialog
    });
    dialogRef.afterClosed().subscribe((result) => {});
  }

  ngOnInit(): void {
    this.userDataSubscription = this.userDataService.userData$.subscribe(() => {
      this.fetchUserData();
    });
    setTimeout(() => {
      this.showSpinner = false;
    }, 1000);
  }

  @ViewChild(MatSort) sort!: MatSort;

  ngOnDestroy(): void {
    this.userDataSubscription.unsubscribe();
  }
  onSortChange(sort: Sort): void {
    if (this.sortField === sort.active) {
      this.sortType = this.sortType === "asc" ? "desc" : "asc";
    } else {
      this.sortType = "desc";
    }
    this.sortField = sort.active || "defaultField";
    this.fetchUserData();
  }

  isCurrentPage(page: number | string): boolean {
    return page === this.pageEvent.page;
  }

  getCustomPageRange(): (number | string)[] {
    const currentPage = this.pageEvent.page;
    const totalPage = this.pageEvent.totalPage;

    const pageRange = 3; // Set the desired pagination length

    const startPage = Math.max(1, currentPage - Math.floor(pageRange / 2));
    const endPage = Math.min(totalPage, startPage + pageRange - 1);

    const pages: (number | string)[] = [];

    if (currentPage > 1) {
      pages.push("<");
    }

    if (startPage > 1) {
      pages.push(1);
    }

    if (startPage > 2) {
      pages.push("...");
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }

    if (endPage < totalPage) {
      pages.push("...");
    }

    if (endPage !== totalPage) {
      pages.push(totalPage);
    }

    if (currentPage < totalPage) {
      pages.push(">");
    }

    return pages;
  }

  onPageClick(page: number | string): void {
    const totalPage = this.pageEvent.totalPage;

    if (page === "<") {
      if (this.pageEvent.page > 1) {
        this.pageEvent.page = this.pageEvent.page - 1;
        this.fetchUserData();
      }
    } else if (page === ">") {
      if (this.pageEvent.page < totalPage) {
        this.pageEvent.page = this.pageEvent.page + 1;
        this.fetchUserData();
      }
    } else if (typeof page === "number") {
      if (page >= 1 && page <= totalPage) {
        this.pageEvent.page = page;
        this.fetchUserData();
      } else {
        console.warn("Invalid page number");
      }
    }
  }
  fetchUserData(): void {
    const page = this.pageEvent.page;
    this.apiService
      .getUser(page, this.size, this.sortField, this.sortType,this.refreshToken,
        this.isError)
      .subscribe({
        next: (response:any) => {
          const responseData = response;
          if (responseData.status == 200) {
            this.userData = responseData?.data?.data;
            const paginteData = responseData?.data;
            this.pageEvent = {
              page: paginteData.page,
              pageSize: paginteData.pageSize,
              totalPage: paginteData.totalPages,
              totalRecords: paginteData.totalRecords,
            };
          }
        },
        error: (error) => {
          console.error("Error fetching transaction data:", error);
          if (error.status === 403) {
            this.isError = true;
            this.openSnackBar("User logged out");

            setTimeout(() => {
              this.app.logout();
            }, 2000);
          }
          if (error.status === 401) {
            this.isError = true;
            const refreshToken:any = sessionStorage.getItem("refreshToken");

            // Call refreshToken method
            this.apiService.refreshToken(refreshToken).subscribe({
              next: (res:any) => {
                this.refreshToken = res.data.accessToken
                sessionStorage.removeItem("accessToken");
                sessionStorage.removeItem("refreshToken");
                if (res.data.accessToken && res.data.refreshToken) {
                  sessionStorage.setItem("accessToken", res.data.accessToken);
                  sessionStorage.setItem("refreshToken", res.data.refreshToken);
                }
                // Retry fetchTransaction after token refresh
                this.fetchUserData();
              },
              error: (refreshError) => {
                console.error("Error refreshing token:", refreshError);
                this.isError = true;
                this.openSnackBar("User logged out");
  
                setTimeout(() => {
                  this.app.logout();
                }, 2000);
              },
            });
          }
        },
      });
  }

  calculateMin(): number {
    let minvalue = (this.pageEvent.page - 1) * this.pageEvent.pageSize + 1;

    return minvalue > this.pageEvent.totalRecords
      ? this.pageEvent.totalRecords
      : minvalue;
  }

  calculateMax(): number {
    let minvalue = this.pageEvent.page * this.pageEvent.pageSize;
    return minvalue > this.pageEvent.totalRecords
      ? this.pageEvent.totalRecords
      : minvalue;
  }
  calculateTotal(): number {
    return this.pageEvent.totalRecords;
  }
  openSnackBar(message: string) {
    this.snackBar.open(message, "x", {
      duration: this.isError ? 3000 : 5000, // Optional: Set duration in milliseconds
      horizontalPosition: "center", // Optional: Set horizontal position
      verticalPosition: "top",
      panelClass: this.isError
        ? ["mat-mdc-snack-bar-container", "red"]
        : ["mat-mdc-snack-bar-container", "green"],
    });
  }
}
